import { useContext } from 'react'

import { UserContext } from '../../constants'

const useUser = () => {
    const context = useContext(UserContext)

    if (context === undefined) {
        throw new Error('UserContext must be within provider')
    }

    const dealerName = context.dealer?.name
    const businessUnitName = context.businessUnit?.internalName
    const businessUnitBrandName = context.businessUnitBrand?.name

    const hasFullBusinessContext = !!dealerName?.trim() && !!businessUnitName?.trim() && !!businessUnitBrandName?.trim()
    const authenticatedWithFullContext = !!context.authenticated && hasFullBusinessContext

    return {
        ...context,
        hasFullBusinessContext,
        authenticatedWithFullContext,
    }
}

export default useUser
